<div *ngIf="machine">
  <h4><p class="text-center">{{machine.name}}</p></h4>

  <div class="row ui-toolbar">
    <div class="col-6">
      <button type="button" class="btn btn-outline-secondary" (click)="printMachine('printable')">
        <div class="d-sm-block">
          <i class="fa fa-print"></i>
        </div>
        <div class="d-none d-sm-block last">
          Afdrukken
        </div>
      </button>
      <button type="button" class="btn btn-outline-secondary" (click)="historyMachine()">
        <div class="d-sm-block">
          <i class="fa fa-history"></i>
        </div>
        <div class="d-none d-sm-block last">
          Vorig onderhoud
        </div>
      </button>
    </div>
    <div class="col-6">
      <div class="pull-right">
        <button type="button" class="btn btn-outline-secondary" *ngIf="machine.active" [disabled]="!readOnly"
                (click)="editMachine()">
          <div class="d-sm-block">
            <i class="fa fa-pencil"></i>
          </div>
          <div class="d-none d-sm-block last">
            Bewerken
          </div>
        </button>
        <button type="button" class="btn btn-outline-danger" *ngIf="machine.active" [disabled]="!readOnly"
                (click)="deleteMachine()">
          <div class="d-sm-block">
            <i class="fa fa-trash-o"></i>
          </div>
          <div class="d-none d-sm-block last">
            Verwijderen
          </div>
        </button>
      </div>
    </div>
  </div>
  <div class="row ui-toolbar-second" *ngIf="machine.active">
    <div class="col-12">
      <button *ngIf="readOnly" type="button" class="btn btn-info btn-block" [disabled]="!machine.active"
              (click)="startMaintenance()">
        <i class="fa fa-play"></i>
        Onderhoud starten
      </button>
      <button *ngIf="!readOnly" type="button" class="btn btn-success btn-block" [disabled]="!machine.active"
              (click)="finishMaintenance()">
        <i class="fa fa-check"></i>
        Onderhoud afronden
      </button>
    </div>
  </div>
  <div class="card">
    <div class="card-block">
      <div class="row">
        <div class="col-md-4 col-xs-12">
          <div class="row">
            <div class="col-12">
              <strong>Afbeelding</strong>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              {{machine.image}}
            </div>
          </div>
        </div>
        <div class="col-md-4 col-xs-12">
          <div class="row">
            <div class="col-5">
              <strong>Type</strong>
            </div>
            <div class="col-7">
              {{machine.type}}
            </div>
          </div>
          <div class="row">
            <div class="col-5">
              <strong>Nummer</strong>
            </div>
            <div class="col-7">
              {{machine.number}}
            </div>
          </div>
          <div class="row">
            <div class="col-5">
              <strong>Vermogen</strong>
            </div>
            <div class="col-7">
              {{machine.vermogen}}
            </div>
          </div>
          <div class="row">
            <div class="col-5">
              <strong>Spanning</strong>
            </div>
            <div class="col-7">
              {{machine.spanning}}
            </div>
          </div>
          <div class="row">
            <div class="col-5">
              <strong>P-onbelast</strong>
            </div>
            <div class="col-7">
              {{machine.ponbelast}}
            </div>
          </div>
          <div class="row">
            <div class="col-5">
              <strong>Delta-p</strong>
            </div>
            <div class="col-7">
              {{machine.deltap}}
            </div>
          </div>
        </div>
        <div class="col-md-4 col-xs-12">
          <div class="row">
            <div class="col-5">
              <strong>Bouwjaar</strong>
            </div>
            <div class="col-7">
              {{machine.manufactureYear}}
            </div>
          </div>
          <div class="row">
            <div class="col-5">
              <strong>Serienummer</strong>
            </div>
            <div class="col-7">
              {{machine.serial}}
            </div>
          </div>
          <div class="row" *ngIf="isAdmin()">
            <div class="col-5">
              <strong>Prijs</strong>
            </div>
            <div class="col-7">
              {{machine.price}}
            </div>
          </div>
          <div class="row">
            <div class="col-5">
              <strong>Leverdatum</strong>
            </div>
            <div class="col-7">
              {{machine.supplyDate | date:'d-M-y'}}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12"><strong>Bijzonderheden</strong></div>
        <div class="col-12">{{machine.notes}}</div>
      </div>
    </div>
  </div>

  <h4><p class="text-center">Onderhoud gegevens</p></h4>

  <div class="card" *ngIf="!machine.currentMachineMaintenance">
    <div class="card-block">
      <p class="text-center">Geen gegevens</p>
    </div>
  </div>

  <div class="card" *ngIf="machine.currentMachineMaintenance">
    <div class="card-block">
      <ng-container *ngIf="machine.type !== 'Compressor'">
        <div class="form-group row">
          <label class="col-form-label col-md-2 col-sm-12"><strong>Filter elem</strong></label>
          <div class="col-md-10 col-sm-12">
            <label class="form-check-label">
              <input class="form-check-input" pInputText type="checkbox" [disabled]="readOnly"
                     [(ngModel)]="machine.currentMachineMaintenance.filterelem">
              Vervangen
            </label>
            Type: {{machine.filterelem}}
            <div *ngIf="isAdmin()">Prijs: {{machine.filterelemprice}}</div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="machine.type==='Compressor'">
        <div class="form-group row">
          <label class="col-form-label col-md-2 col-sm-12"><strong>Draaiuren</strong></label>
          <div class="col-md-10 col-sm-12"><input class="form-control" pInputText type="number" [disabled]="readOnly"
                                                  [(ngModel)]="machine.currentMachineMaintenance.hours"></div>
        </div>

        <div class="form-group row">
          <label class="col-form-label col-md-2 col-sm-12"><strong>Draaiuren onbelast</strong></label>
          <div class="col-md-10 col-sm-12"><input class="form-control" pInputText type="number" [disabled]="readOnly"
                                                  [(ngModel)]="machine.currentMachineMaintenance.nethours"></div>
        </div>

        <div class="form-group row">
          <label class="col-form-label col-md-2 col-sm-12"><strong>Oliepeil</strong></label>
          <div class="col-md-10 col-sm-12"><input class="form-control" pInputText type="text" [disabled]="readOnly"
                                                  [(ngModel)]="machine.currentMachineMaintenance.oillevel"></div>
        </div>

        <div class="form-group row">
          <label class="col-form-label col-md-2 col-sm-12"><strong>Drukschakelaar</strong></label>
          <div class="col-md-10 col-sm-12">
            <div class="row col-12">
              <label class="form-check-label">
                <input class="form-check-input" pInputText type="checkbox" [disabled]="readOnly"
                       [(ngModel)]="machine.currentMachineMaintenance.pressureswitch">
                Vervangen
              </label>
            </div>

            Type: {{machine.pressureswitch}}
            <div *ngIf="isAdmin()">Prijs: {{machine.pressureswitchPrice}}</div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-form-label col-md-2 col-sm-12"><strong>Seperator elem</strong></label>
          <div class="col-md-10 col-sm-12">
            <div class="row col-12">
              <label class="form-check-label">
                <input class="form-check-input" pInputText type="checkbox" [disabled]="readOnly"
                       [(ngModel)]="machine.currentMachineMaintenance.seperator">
                Vervangen
              </label>
            </div>
            Type: {{machine.seperatorelem}}
            <div *ngIf="isAdmin()">Prijs: {{machine.seperatorelemPrice}}</div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-form-label col-md-2 col-sm-12"><strong>Oliefilter</strong></label>
          <div class="col-md-10 col-sm-12">
            <div class="row col-12">
              <label class="form-check-label">
                <input class="form-check-input" pInputText type="checkbox" [disabled]="readOnly"
                       [(ngModel)]="machine.currentMachineMaintenance.oilfilter">
                Vervangen
              </label>
            </div>
            Type: {{machine.oilfilter}}
            <div *ngIf="isAdmin()">Prijs: {{machine.oilfilterPrice}}</div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-form-label col-md-2 col-sm-12"><strong>Luchtfilter</strong></label>
          <div class="col-md-10 col-sm-12">
            <div class="row col-12">
              <label class="form-check-label">
                <input class="form-check-input" pInputText type="checkbox" [disabled]="readOnly"
                       [(ngModel)]="machine.currentMachineMaintenance.airfilter">
                Vervangen
              </label>
            </div>
            Type: {{machine.airfilter}}
            <div *ngIf="isAdmin()">Prijs: {{machine.airfilterPrice}}</div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-form-label col-md-2 col-sm-12"><strong>V-snaar</strong></label>
          <div class="col-md-10 col-sm-12">
            <div class="row col-12">
              <label class="form-check-label">
                <input class="form-check-input" pInputText type="checkbox" [disabled]="readOnly"
                       [(ngModel)]="machine.currentMachineMaintenance.vbelt">
                Vervangen
              </label>
            </div>
            Type: {{machine.vbelt}}
            <div *ngIf="isAdmin()">Prijs: {{machine.vbeltPrice}}</div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-form-label col-md-2 col-sm-12"><strong>M.P.V</strong></label>
          <div class="col-md-10 col-sm-12"><input class="form-control" pInputText type="text" [disabled]="readOnly"
                                                  [(ngModel)]="machine.currentMachineMaintenance.mpv"></div>
        </div>

        <div class="form-group row">
          <label class="col-form-label col-md-2 col-sm-12"><strong>Klein materiaal</strong></label>
          <div class="col-md-10 col-sm-12"><input class="form-control" pInputText type="text" [disabled]="readOnly"
                                                  [(ngModel)]="machine.currentMachineMaintenance.smallmaterials"></div>
        </div>

        <div class="form-group row">
          <label class="col-form-label col-md-2 col-sm-12"><strong>Delta P</strong></label>
          <div class="col-md-10 col-sm-12"><input class="form-control" pInputText type="text" [disabled]="readOnly"
                                                  [(ngModel)]="machine.currentMachineMaintenance.deltap"></div>
        </div>

        <div class="form-group row">
          <label class="col-form-label col-md-2 col-sm-12"><strong>P onbelast</strong></label>
          <div class="col-md-10 col-sm-12"><input class="form-control" pInputText type="text" [disabled]="readOnly"
                                                  [(ngModel)]="machine.currentMachineMaintenance.netp"></div>
        </div>

        <div class="form-group row">
          <label class="col-form-label col-md-2 col-sm-12"><strong>Temperatuur</strong></label>
          <div class="col-md-10 col-sm-12"><input class="form-control" pInputText type="text" [disabled]="readOnly"
                                                  [(ngModel)]="machine.currentMachineMaintenance.temperature"></div>
        </div>

        <div class="form-group row">
          <label class="col-form-label col-md-2 col-sm-12"><strong>Amperage</strong></label>
          <div class="col-md-10 col-sm-12"><input class="form-control" pInputText type="text" [disabled]="readOnly"
                                                  [(ngModel)]="machine.currentMachineMaintenance.amperage"></div>
        </div>

        <div class="form-group row">
          <label class="col-form-label col-md-2 col-sm-12"><strong>Spanning</strong></label>
          <div class="col-md-10 col-sm-12"><input class="form-control" pInputText type="text" [disabled]="readOnly"
                                                  [(ngModel)]="machine.currentMachineMaintenance.pressure"></div>
        </div>
      </ng-container>
      <div class="form-group row">
        <label class="col-form-label col-md-2 col-sm-12"><strong>Notities</strong></label>
        <div class="col-md-10 col-sm-12"><textarea class="form-control" pInputTextarea [disabled]="readOnly"
                                                   [(ngModel)]="machine.currentMachineMaintenance.notes"></textarea>
        </div>
      </div>

      <button type="button" class="btn btn-primary" *ngIf="!readOnly" (click)="saveMaintenance()">
        Opslaan
      </button>

    </div>
  </div>

  <p-dialog header="Onderhoud afronden" [(visible)]="displayNewApointment" [modal]="true">
    <pre class="alert alert-danger" *ngIf="newError">{{newError}}</pre>

    <div class="form-group row">
      <label class="col-form-label col-md-3 col-sm-12">Type</label>
      <div class="col-md-9 col-sm-12">
        <p-dropdown class="dropdown" [options]="maintenanceTypes" [(ngModel)]="selectedMaintenance"></p-dropdown>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-form-label col-md-3 col-sm-12">Werkuren</label>
      <div class="col-md-9 col-sm-12"><input class="form-control" [(ngModel)]="workhours" type="number"></div>
    </div>

    <div class="form-group row">
      <label class="col-form-label col-md-3 col-sm-12">Reisuren</label>
      <div class="col-md-9 col-sm-12"><input class="form-control" [(ngModel)]="travelhours" type="number"></div>
    </div>

    <div class="form-group row">
      <label class="col-form-label col-md-3 col-sm-12">Kilometers</label>
      <div class="col-md-9 col-sm-12"><input class="form-control" [(ngModel)]="traveldistance" type="number"></div>
    </div>

    <div class="form-group row" *ngIf="!isIncident()">
      <label class="col-form-label col-md-3 col-sm-12">Datum</label>
      <div class="col-md-9 col-sm-12">
        <p-calendar [(ngModel)]="newDate" dateFormat="dd-mm-yy"></p-calendar>
      </div>
    </div>

    <p-footer>
      <button type="button" class="btn btn-primary" (click)="saveNewApointment()">
        Afronden
      </button>
      <button type="button" class="btn btn-outline-secondary" (click)="displayNewApointment = false">
        Annuleren
      </button>
    </p-footer>
  </p-dialog>
</div>

<div *ngIf="machine" [hidden]="true" id="printable" style="background-color: white; padding: 10px;">
  <h2>Machine {{machine.name}}</h2>

  <table style="width:100%" class="table">
    <tr>
      <th width="200px;" align="left">Type</th>
      <td>{{machine.type}}</td>
    </tr>
    <tr *ngIf="machine.type==='Compressor'">
      <th width="200px;" align="left">Compressor type</th>
      <td>{{machine.compressortype}}</td>
    </tr>
    <tr>
      <th width="200px;" align="left">Nummer</th>
      <td>{{machine.number}}</td>
    </tr>
    <tr>
      <th width="200px;" align="left">Bouwjaar</th>
      <td>{{machine.manufactureYear}}</td>
    </tr>
    <tr>
      <th width="200px;" align="left">Serienummer</th>
      <td>{{machine.serial}}</td>
    </tr>
    <tr [hidden]="isAdmin()">
      <th width="200px;" align="left">Prijs</th>
      <td>{{machine.price}}</td>
    </tr>
    <tr>
      <th width="200px;" align="left">Leverdatum</th>
      <td>{{machine.supplyDate| date:'dd-MM-yyyy'}}</td>
    </tr>
    <tr>
      <th align="left" colspan="2">Bijzonderheden</th>
    </tr>
    <tr>
      <td colspan="2">{{machine.notes}}</td>
    </tr>
  </table>
  <h2>Onderhoud</h2>
  <table style="width:100%" class="table" *ngIf="machine.currentMachineMaintenance">
    <tr>
      <th width="200px;" style="border-top:1px solid black" align="left">Draai uren</th>
      <td width="300px;" style="border-top:1px solid black">{{machine.currentMachineMaintenance.hours}}</td>
    </tr>
    <tr>
      <th width="200px;" align="left">Draaiuren onbelast</th>
      <td width="300px;">{{machine.currentMachineMaintenance.nethours}}</td>
    </tr>
    <tr>
      <th width="200px;" align="left">Oliepeil</th>
      <td width="300px;">{{machine.currentMachineMaintenance.oillevel}}</td>
    </tr>

    <tr>
      <th style="border-top:1px solid black" align="left" colspan="2">Drukschakelaar</th>
    </tr>
    <tr>
      <th width="200px;" align="left">Vervangen</th>
      <td width="300px;">{{machine.currentMachineMaintenance.pressureswitch}}</td>
    </tr>
    <tr>
      <th width="200px;" align="left">Type</th>
      <td width="300px;">{{machine.pressureswitch}}</td>
      <th width="100px;" [hidden]="!isAdmin()" align="left">Prijs</th>
      <td width="100px;" [hidden]="!isAdmin()">{{machine.pressureswitchPrice}}</td>
    </tr>

    <tr>
      <th style="border-top:1px solid black" align="left" colspan="2">Seperator elem</th>
    </tr>
    <tr>
      <th width="200px;" align="left">Vervangen</th>
      <td width="300px;">{{machine.currentMachineMaintenance.seperator}}</td>
    </tr>
    <tr>
      <th width="200px;" align="left">Type</th>
      <td width="300px;">{{machine.seperatorelem}}</td>
      <th width="100px;" [hidden]="!isAdmin()" align="left">Prijs</th>
      <td width="100px;" [hidden]="!isAdmin()">{{machine.seperatorelemPrice}}</td>
    </tr>

    <tr>
      <th style="border-top:1px solid black" align="left" colspan="2">Oliefilter</th>
    </tr>
    <tr>
      <th width="200px;" align="left">Vervangen</th>
      <td width="300px;">{{machine.currentMachineMaintenance.oilfilter}}</td>
    </tr>
    <tr>
      <th width="200px;" align="left">Type</th>
      <td width="300px;">{{machine.oilfilter}}</td>
      <th width="100px;" [hidden]="!isAdmin()" align="left">Prijs</th>
      <td width="100px;" [hidden]="!isAdmin()">{{machine.oilfilterPrice}}</td>
    </tr>

    <tr>
      <th style="border-top:1px solid black" align="left" colspan="2">Luchtfilter</th>
    </tr>
    <tr>
      <th width="200px;" align="left">Vervangen</th>
      <td width="300px;">{{machine.currentMachineMaintenance.airfilter}}</td>
    </tr>
    <tr>
      <th width="200px;" align="left">Type</th>
      <td width="300px;">{{machine.airfilter}}</td>
      <th width="100px;" [hidden]="!isAdmin()" align="left">Prijs</th>
      <td width="100px;" [hidden]="!isAdmin()">{{machine.airfilterPrice}}</td>
    </tr>

    <tr>
      <th style="border-top:1px solid black" align="left" colspan="2">V-snaar</th>
    </tr>
    <tr>
      <th width="200px;" align="left">Vervangen</th>
      <td width="300px;">{{machine.currentMachineMaintenance.vbelt}}</td>
    </tr>
    <tr>
      <th width="200px;" align="left">Type</th>
      <td width="300px;">{{machine.vbelt}}</td>
      <th width="100px;" [hidden]="!isAdmin()" align="left">Prijs</th>
      <td width="100px;" [hidden]="!isAdmin()">{{machine.vbeltPrice}}</td>
    </tr>

    <tr>
      <th width="200px;" style="border-top:1px solid black" align="left">M.P.V</th>
      <td width="300px;" style="border-top:1px solid black">{{machine.currentMachineMaintenance.mpv}}</td>
    </tr>
    <tr>
      <th width="200px;" align="left">Klein materiaal</th>
      <td width="300px;">{{machine.currentMachineMaintenance.smallmaterials}}</td>
    </tr>
    <tr>
      <th width="200px;" align="left">Delta P</th>
      <td width="300px;">{{machine.currentMachineMaintenance.deltap}}</td>
    </tr>
    <tr>
      <th width="200px;" align="left">P onbelast</th>
      <td width="300px;">{{machine.currentMachineMaintenance.netp}}</td>
    </tr>
    <tr>
      <th width="200px;" align="left">Temperatuur</th>
      <td width="300px;">{{machine.currentMachineMaintenance.temperature}}</td>
    </tr>
    <tr>
      <th width="200px;" align="left">Amperage</th>
      <td width="300px;">{{machine.currentMachineMaintenance.amperage}}</td>
    </tr>
    <tr>
      <th width="200px;" align="left">Spanning</th>
      <td width="300px;">{{machine.currentMachineMaintenance.pressure}}</td>
    </tr>
    <tr>
      <th align="left" colspan="2">Notities</th>
    </tr>
    <tr>
      <td colspan="2">{{machine.currentMachineMaintenance.notes}}</td>
    </tr>
  </table>
</div>



// WEBPACK FOOTER //
// ./src/app/pages/machine/details/machine.details.component.html